import { useMediaQuery } from '@/hooks/useMediaQuery';

export function useCompactChart() {
	const isCompact = useMediaQuery('(max-width: 767px)');

	const rowHeight = (count: number) => {
		if (!isCompact) return undefined;
		return Math.max(40 * count + 60, 200);
	};

	return { isCompact, rowHeight };
}
